import {
    FETCH_CLAIMS_REQUEST, FETCH_CLAIMS_SUCCESS, FETCH_CLAIMS_FAILURE,
    CREATE_CLAIM_SUCCESS, UPDATE_CLAIM_SUCCESS, DELETE_CLAIM_SUCCESS
  } from '../actions/claimActions';
  
  const initialState = {
    claims: [],
    loading: false,
    error: null,
  };
  
  export default function claimReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_CLAIMS_REQUEST:
        return { ...state, loading: true };
      case FETCH_CLAIMS_SUCCESS:
        return { ...state, loading: false, claims: action.payload };
      case FETCH_CLAIMS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_CLAIM_SUCCESS:
        return { ...state, claims: [...state.claims, action.payload] };
      case UPDATE_CLAIM_SUCCESS:
        return {
          ...state,
          claims: state.claims.map((claim) =>
            claim.id === action.payload.id ? action.payload : claim
          ),
        };
      case DELETE_CLAIM_SUCCESS:
        return {
          ...state,
          claims: state.claims.filter((claim) => claim.id !== action.payload),
        };
      default:
        return state;
    }
  }
  